/**
 * Permission claim values, mirroring `SharedUI/Identity/Permissions.cs`.
 *
 * These exist because the claim value is not derivable from the C# path that
 * declares it, and the two do not even agree with each other across areas:
 *
 *   Permissions.Auth.Users.View          →  "Permissions.Users.View"
 *   Permissions.Auth.Roles.View          →  "Permissions.Auth.Roles.View"
 *   Permissions.Auth.AuditLogs.View      →  "Permissions.Auth.AuditLogs.View"
 *   Permissions.Menus.View               →  "Permissions.Menus.View"
 *
 * Users drops the `Auth` segment; Roles and AuditLogs keep it. Guessing from the
 * nesting produced a wrong string twice during Phase 4, and a wrong permission
 * fails closed — the buttons simply vanish, with nothing logged. Copy the value
 * from the C# constant when adding to this file; do not infer it.
 *
 * The server remains the enforcement point. These only decide what renders.
 */
export const Permission = {
  users: {
    view: 'Permissions.Users.View',
    create: 'Permissions.Users.Create',
    edit: 'Permissions.Users.Edit',
    delete: 'Permissions.Users.Delete',
    lock: 'Permissions.Users.Lock',
    unlock: 'Permissions.Users.Unlock',
    resetPassword: 'Permissions.Users.ResetPassword',
    manageRoles: 'Permissions.Users.ManageRoles',
  },
  roles: {
    view: 'Permissions.Auth.Roles.View',
    create: 'Permissions.Auth.Roles.Create',
    edit: 'Permissions.Auth.Roles.Edit',
    delete: 'Permissions.Auth.Roles.Delete',
    managePermissions: 'Permissions.Auth.Roles.ManagePermissions',
  },
  auditLogs: {
    view: 'Permissions.Auth.AuditLogs.View',
    export: 'Permissions.Auth.AuditLogs.Export',
    delete: 'Permissions.Auth.AuditLogs.Delete',
  },
  menus: {
    view: 'Permissions.Menus.View',
    create: 'Permissions.Menus.Create',
    edit: 'Permissions.Menus.Edit',
    delete: 'Permissions.Menus.Delete',
    reorder: 'Permissions.Menus.Reorder',
  },
} as const;
